<template>
  <div class="header">
    <div class="w1400">
      <div class="headBox">
        <div class="logo">
          <router-link to="/" class="flex-cc">
            <el-image
              :src="require('@/assets/logo.png')"
              fit="contain"
            ></el-image>
            <div class="xian"></div>
            <div class="tit-18 cor-000">UniXMAII</div>
          </router-link>
        </div>

        <nav>
          <ul>
            <li
              v-for="item in list"
              :key="item.name"
              :class="{ active: isActive(item.url) }"
              @mouseover="handleMouseOver(item)"
              @mouseleave="handleMouseLeave()"
            >
              <template>
                <router-link :to="item.url" v-if="item.url">{{
                  item.name
                }}</router-link>
                <router-link to="" v-else>{{ item.name }}</router-link>
              </template>
              <!-- <template v-else>
                  <a class="no-link">{{ item.name }}</a>
                </template> -->

              <el-collapse-transition>
                <!-- 三级导航 -->
                <div
                  class="proDown"
                  v-if="!item.list2 || item.list2.length === 0"
                  v-show="hoverItem === item"
                >
                  <div class="w1300">
                    <div class="box">
                      <div class="layui-tab">
                        <ul class="tabs-header">
                          <li
                            :class="{ 'layui-this': activeTab === indexx }"
                            @mouseenter="switchTab(indexx)"
                            v-for="(ll, indexx) in item.list3"
                          >
                            <a href="javascript:;">
                              {{ ll.ming }}
                            </a>
                          </li>
                        </ul>
                        <div class="tabs-body">
                          <div
                            class="layui-tab-item item"
                            v-for="(tabItem, tabIndex) in item.list3"
                            :key="tabIndex"
                            :class="{ 'layui-show': activeTab === tabIndex }"
                          >
                            <!-- 再循环当前标签下的 haizi 列表 -->
                            <div class="list">
                              <ul>
                                <li
                                  v-for="(ls, indexxx) in tabItem.sp"
                                  :key="indexxx"
                                >
                                  <router-link
                                    :to="{
                                      name: 'prodetail',
                                      params: { id: ls.id },
                                    }"
                                    :title="ls.ming"
                                  >
                                    <div class="imgBox">
                                      <img
                                        v-if="ls.tu"
                                        :src="ls.tu ? ls.tu : ''"
                                        :alt="ls.ming"
                                        :title="ls.ming"
                                      />
                                    </div>
                                    <span>{{ ls.ming }}</span>
                                  </router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 二级导航 -->
                <div
                  class="navTwo"
                  v-if="item.list2 && item.list2.length > 0"
                  v-show="hoverItem === item"
                >
                  <div class="w1300">
                    <dl class="child">
                      <dd v-for="item2 in item.list2" :key="item2.name">
                        <router-link
                          :to="{
                            name: 'prodetail',
                            params: { id: item2.id },
                          }"
                          :title="item2.ming"
                        >
                          <el-image :src="item2.tu" fit="contain"></el-image>
                          <span> {{ item2.ming }}</span>
                        </router-link>
                      </dd>
                    </dl>
                  </div>
                </div>
              </el-collapse-transition>
            </li>
          </ul>
        </nav>

        <div class="header-right flex-c">
          <div v-if="isLoggedIn" class="flex-cc">
            <router-link to="/shoppingCart" class="car">
              <i
                class="el-icon-shopping-cart-2 tit-24"
                style="color: #231815"
              ></i>
              <el-badge
                size="small"
                class="mark"
                :value="cartCount === 0 ? '' : cartCount"
                :max="99"
              />
            </router-link>

            <div class="user">
              <router-link to="/user/userInfo">
                <div class="icBox flex" v-popover:popover>
                  <svg
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                  >
                    <path
                      d="M855.8 761.2c-4.6-22.5-11.5-44.6-20.4-65.7-8.8-20.7-19.6-40.7-32.3-59.5-12.5-18.5-26.9-35.9-42.7-51.8-15.8-15.8-33.2-30.2-51.8-42.7-18.7-12.6-38.7-23.5-59.5-32.3-4.2-1.8-8.5-3.5-12.8-5.1 11.5-7.8 22.3-16.8 32.4-26.8 42-42 65.1-97.8 65.1-157.2s-23.1-115.1-65.1-157S571 98 511.6 98c-59.4 0-115.2 23.1-157.2 65.1-42 42-65.1 97.8-65.1 157.2s23.1 115.2 65.1 157.2c10.3 10.3 21.5 19.5 33.4 27.5-3.7 1.4-7.4 2.9-11 4.4-20.7 8.8-40.7 19.6-59.5 32.3-18.5 12.5-35.9 26.9-51.8 42.7-15.8 15.8-30.2 33.2-42.7 51.8-12.6 18.7-23.5 38.7-32.3 59.5-8.9 21.1-15.8 43.2-20.4 65.7-4.7 23.1-7.1 46.8-7.1 70.5 0 16.6 13.4 30 30 30h639.8c16.6 0 30-13.4 30-30 0.1-23.9-2.3-47.6-7-70.7z m-506.5-441c0-89.5 72.8-162.3 162.3-162.3 89.5 0 162.3 72.8 162.3 162.3 0 85.3-66.2 155.5-150 161.8-7.8-0.2-15.7-0.2-23.5 0.1-84.3-5.8-151.1-76.2-151.1-161.9zM224.6 801.7c1-9.6 2.4-19.1 4.4-28.5 3.8-18.6 9.5-36.9 16.9-54.4 7.3-17.2 16.3-33.7 26.7-49.2 10.4-15.4 22.3-29.8 35.4-42.9 13.1-13.1 27.6-25 42.9-35.4 15.5-10.5 32.1-19.5 49.2-26.7 17.5-7.4 35.8-13.1 54.4-16.9 14.7-3 29.8-4.9 44.9-5.5 4 0.2 8.1 0.3 12.1 0.3 4.4 0 8.8-0.1 13.2-0.4 15.7 0.6 31.4 2.5 46.7 5.6 18.6 3.8 36.9 9.5 54.4 16.9 17.2 7.3 33.7 16.3 49.2 26.7 15.4 10.4 29.8 22.3 42.9 35.4 13.1 13.1 25 27.6 35.4 42.9 10.5 15.5 19.5 32.1 26.7 49.2 7.4 17.5 13.1 35.8 16.9 54.4 1.9 9.4 3.4 18.9 4.4 28.5H224.6z"
                      fill="#000002"
                    ></path>
                  </svg>
                </div>
              </router-link>

              <el-popover
                ref="popover"
                placement="bottom-end"
                width="auto"
                trigger="hover"
              >
                <div class="userPopover">
                  <div class="userTop flex-c">
                    <div class="imgBox">
                      <el-image
                        :src="require('@/assets/logo2.png')"
                        fit="contain"
                      ></el-image>
                    </div>
                    <div class="info">
                      <div class="name tit-14 cor-000">
                        账号名称：{{ yonghu.nicheng }}
                      </div>
                      <div class="tip tit-12">
                        <span v-if="shenghezhuangtai == 0">个人账户</span>
                        <span
                          v-if="shenghezhuangtai == 1 || shenghezhuangtai == 3"
                          >企业账户未认证</span
                        >
                        <span v-if="shenghezhuangtai == 2">企业账户</span>
                      </div>
                    </div>
                  </div>
                  <div class="userBom flex">
                    <router-link to="/user/order" class="item flex-cc">
                      我的订单
                    </router-link>
                    <router-link to="/user/userInfo" class="item flex-cc">
                      账号管理
                    </router-link>
                    <div class="item flex-cc cur" @click="logout">退出</div>
                  </div>
                </div>
              </el-popover>
            </div>
          </div>
          <!-- 未登录状态下显示登录/注册 -->
          <div v-else>
            <div class="login-register">
              <el-dropdown class="flex-c">
                <span class="el-dropdown-link">
                  <router-link to="/login">登录/</router-link></span
                >
                <span class="el-dropdown-link"
                  ><router-link to="/register">注册</router-link></span
                >
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <router-link to="/login">登录</router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link to="/register">注册</router-link>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

          <!-- 移动端按钮 -->
          <div class="mobmenu" @click="openNav">
            <dl>
              <dd></dd>
              <dd></dd>
              <dd></dd>
            </dl>
            <!-- <h4>Menu</h4> -->
          </div>
        </div>
      </div>
    </div>

    <div class="mobnav">
      <div
        class="mobmask"
        :class="{ active: isNavOpen }"
        @click="closeMobNav"
      ></div>
      <div class="mobnavBox" :class="{ active: isNavOpen }">
        <div class="top flex-sbc">
          <div class="logo">
            <el-image
              class="logo_svg"
              :src="require('@/assets/logo.png')"
              fit="contain"
              alt="{$config.admin_site_title}"
              title="{$config.admin_site_title}"
            ></el-image>
            <div class="xian"></div>
            <div class="tit-18 cor-000">UniXMAII</div>
          </div>
          <i class="mobnavclose" @click="closeMobNav"></i>
        </div>
        <div class="mobCon">
          <div class="bottom">
            <ul class="nav">
              <!-- 循环渲染导航列表 -->
              <li
                v-for="item in list"
                :key="item.name"
                :class="{
                  active: isActive(item.url),
                  on: openSubNavId === item.name,
                }"
              >
                <h3 class="flexc-sb" @click="toggleSubNav(item, $event)">
                  <router-link
                    :to="item.url"
                    @click.native="closeNavAfterClick"
                  >
                    {{ item.name }}
                  </router-link>

                  <!-- 有子菜单时显示下拉箭头 -->
                  <i class="flexcc" v-if="item.list3 || item.list2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      width="32"
                      height="32"
                    >
                      <path
                        d="M970.496 543.829333l30.165333-30.165333-415.829333-415.914667a42.837333 42.837333 0 0 0-60.288 0 42.538667 42.538667 0 0 0 0 60.330667l355.413333 355.498667-355.413333 355.285333a42.496 42.496 0 0 0 0 60.288c16.64 16.64 43.861333 16.469333 60.288 0.042667l383.914667-383.701334 1.749333-1.664z"
                        fill="#3D3D3D"
                      ></path>
                    </svg>
                  </i>
                </h3>

                <!-- 三级栏目导航 (对应list3结构) -->
                <div
                  class="m-subnav"
                  v-if="!item.list2 || item.list2.length === 0"
                  v-show="openSubNavId === item.name"
                  ref="subNavRefs"
                >
                  <dl
                    v-for="(tabItem, tabIndex) in item.list3"
                    :key="tabIndex"
                    :class="{ on: activeThirdNav[tabItem.ming] }"
                  >
                    <dt @click="toggleThirdNav(tabItem, $event)">
                      <router-link to="javascript:;">
                        <span>{{ tabItem.ming }}</span>
                      </router-link>
                      <div class="btn">
                        <i
                          class="el-icon-plus i1"
                          v-show="!activeThirdNav[tabItem.ming]"
                        ></i>
                        <i
                          class="el-icon-minus i2"
                          v-show="activeThirdNav[tabItem.ming]"
                        ></i>
                      </div>
                    </dt>
                    <dd v-show="activeThirdNav[tabItem.ming]">
                      <div class="list">
                        <router-link
                          v-for="(childItem, childIndex) in tabItem.sp"
                          :key="childIndex"
                          :to="{
                            name: 'prodetail',
                            params: { id: childItem.id },
                          }"
                          @click.native="closeNavAfterClick"
                        >
                          {{ childItem.ming }}
                        </router-link>
                      </div>
                    </dd>
                  </dl>
                </div>

                <!-- 二级栏目导航 (通用二级菜单) -->
                <div
                  class="m-subnav"
                  v-if="item.list2 && item.list2.length > 0"
                  v-show="openSubNavId === item.name"
                  ref="subNavRefs"
                >
                  <router-link
                    v-for="(childItem, childIndex) in item.list2"
                    :key="childIndex"
                    @click.native="closeNavAfterClick"
                    :to="{
                      name: 'prodetail',
                      params: { id: childItem.id },
                    }"
                    :title="childItem.ming"
                  >
                    {{ childItem.ming }}
                  </router-link>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let that;
export default {
  name: "headerComponent",

  data() {
    return {
      list: [
        // {
        //   name: "首页",
        //   url: "/",
        // },
        // {
        //   name: "整机专区",
        //   url: "/machine",
        // },
        // {
        //   name: "配件专区",
        //   url: null,
        //   list2: [
        //     {
        //       imgUrl: require("@/assets/navTwo-img.png"),
        //       name: "自适应智能夹爪",
        //       url: "/prodetail/1",
        //     },
        //     {
        //       imgUrl: require("@/assets/navTwo-img.png"),
        //       name: "机械臂 ",
        //       url: "/prodetail/2",
        //     },
        //     {
        //       imgUrl: require("@/assets/navTwo-img.png"),
        //       name: "行星式关节模组  ",
        //       url: "/prodetail/3",
        //     },
        //   ],
        // },
        // {
        //   name: "教程",
        //   url: "/video",
        // },
        // {
        //   name: "帮助与支持",
        //   url: "/help",
        // },
      ],
      hoverItem: null, // 存储当前悬停的有二级菜单的项
      hoverTimeout: null,

      cartCount: 0, // 购物车数量

      isLoggedIn: false, // 登录状态
      yonghu: {},
      shenghezhuangtai: 0,

      activeTab: 0, // 默认选中的标签

      // 三级导航状态管理
      // 控制移动端导航是否打开
      isNavOpen: false,
      // 记录当前展开的二级导航ID
      openSubNavId: "",
      // 记录当前展开的三级导航
      activeThirdNav: {},
      // 导航列表数据（需根据实际业务替换）
    };
  },

  created() {
    that = this;
    console.log(33333);
    // 检查登录状态，可以从localStorage或vuex中获取
    that.checkLoginStatus();
    that.CSH(); //导航栏数据初始化
    that.CSH2();
    // console.log(this.$qu('yonghux'))
    if (that.$qu("yonghux")["id"]) {
      that.isLoggedIn = true;
      that.yonghu = that.$qu("yonghux");
    }
    // console.log(333)
  },
  // 关键：监听路由变化，每次切换路由都更新状态
  watch: {
    $route: {
      immediate: true, // 首次加载就执行一次
      handler(to, from) {
        this.CSH2(); //导航栏数据初始化 // 路由切换时重新初始化数据
        // 路由变化时自动收起下拉菜单
        this.closeDropdown();
      },
    },
  },
  // watch: {
  //   $route() {
  //     this.checkLoginStatus();
  //   },
  // },
  methods: {
    // 切换 Tab 的核心方法
    switchTab(tabIndex) {
      this.activeTab = tabIndex;
    },

    isActive(url) {
      // 对于首页需要精确匹配
      if (url === "/") {
        return this.$route.path === url;
      }
      if (url != "") {
        // 其他页面可以包含匹配
        return this.$route.path.includes(url);
      }
    },
    // 显示移动端导航
    openNav() {
      this.isNavOpen = true;
      // 禁止body滚动
      document.body.style.overflowY = "hidden";
    },

    // 关闭移动端导航
    closeMobNav() {
      this.isNavOpen = false;
      // 恢复body滚动
      document.body.style.overflowY = "";
      // 重置展开的导航状态
      this.openSubNavId = "";
      this.activeThirdNav = {};
    },

    // 点击导航链接后关闭菜单（核心新增方法）
    closeNavAfterClick() {
      // 延迟关闭：确保路由跳转先执行，避免跳转被阻断
      setTimeout(() => {
        this.closeMobNav();
      }, 50);
    },

    // 切换二级导航展开/收起
    toggleSubNav(item, e) {
      // 有子菜单时阻止链接跳转
      if (item.list2 || item.list3) {
        e.preventDefault();

        if (this.openSubNavId === item.name) {
          // 收起当前展开的二级导航
          this.openSubNavId = "";
        } else {
          // 关闭其他二级导航，展开当前
          this.openSubNavId = item.name;
          // 重置三级导航状态
          this.activeThirdNav = {};
        }
      }
    },

    // 切换三级导航展开/收起
    toggleThirdNav(tabItem, e) {
      // 有三级菜单时阻止链接跳转
      if (tabItem.sp && tabItem.sp.length > 0) {
        e.preventDefault();

        this.$set(
          this.activeThirdNav,
          tabItem.ming,
          !this.activeThirdNav[tabItem.ming],
        );
      }
    },

    handleMouseOver(item) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = setTimeout(() => {
        this.hoverItem = item.list2 ? item : null;
      }, 100);
    },
    handleMouseLeave() {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = setTimeout(() => {
        this.hoverItem = null;
      }, 200);
    },
    // 收起下拉菜单
    closeDropdown() {
      this.hoverItem = null;
    },

    checkLoginStatus() {
      // 如果是vuex管理状态，可以这样：
      this.isLoggedIn = this.$store.getters.token;
    },

    logout() {
      // 更新登录状态
      // this.isLoggedIn = false;
      that.$post(
        "k=denglu&c=Qinghuancun",
        {
          jianzhi: that.yonghu.kouling,
        },
        function(s) {
          if (s.shi == 1) {
            that.$cun("yonghux", "");
			that.$cun("renzhen", "");
            that.$message.success("退出登录成功");
            that.isLoggedIn = false;
            window.location.reload();
          } else {
            that.$xiaoxi(s.shu);
          }
        },
      );

      // 提示用户已退出

      // 刷新页面以完全重置应用状态
      // window.location.reload();
    },
    // 接口数据
    CSH() {
      var that = this;
      that.$post("k=company&c=tabbar", { leixing: 1 }, function(s) {
        that.list = s.shu.lie;
        // that.zongshu = Number(s.shu.zongshu);
      });
    },
    // 接口数据
    // 接口数据
    CSH2() {
      var that = this;
      that.$post(
        "m=limitao&k=huiyuan",
        { jianzhi: that.yonghu.kouling },
        function(s) {
          if (s.shi == 1) {
            that.shu = s.shu;
            if (that.shu.leixing == 0 && that.shu.renzhenzhuangtai == 0) {
              that.shenghezhuangtai = 0;
            } else if (
              that.shu.leixing == 0 &&
              that.shu.renzhenzhuangtai == 1
            ) {
              that.shenghezhuangtai = 1;
            } else if (
              that.shu.leixing == 1 &&
              that.shu.renzhenzhuangtai == 0
            ) {
              that.shenghezhuangtai = 3;
            } else if (
              that.shu.leixing == 1 &&
              that.shu.renzhenzhuangtai == 2
            ) {
              that.shenghezhuangtai = 2;
            } else if (
              that.shu.leixing == 1 &&
              that.shu.renzhenzhuangtai == 1
            ) {
              that.shenghezhuangtai = 4;
            }
            console.log(that.shenghezhuangtai, "shenghezhuangtai");
            that.$cun("renzhen", that.shenghezhuangtai);
            that.isLoggedIn = true;
          } else if (s.shi == -10) {
            localStorage.removeItem("yonghux");
            that.$message.success("退出登录成功");
            that.isLoggedIn = false;
            window.location.reload();
            that.isLoggedIn = false;
          }
        },
      );
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background: #fff;
  border-bottom: 1px solid #dfdfdf;
}
.header .headBox {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo {
    max-width: 50%;
    .xian {
      width: 1px;
      height: 0.22rem;
      background: #cbcbcb;
      margin: 0 0.2rem;
    }
  }

  nav {
    width: 40%;
    height: 100%;
    > ul {
      height: 100%;
      display: flex;
      justify-content: space-between;
      > li {
        height: 100%;
        > a {
          height: 100%;
          color: #333;
          position: relative;
          display: flex;
          align-items: center;

          &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 2px;
            background: linear-gradient(-7deg, #41b9e0 0%, #001ff5 100%);
            transition: all 0.3s;
          }
        }
        &:hover a:after {
          width: 100%;
        }
        &.active a:after {
          width: 100%;
        }
      }
    }

    // 二级菜单
    .navTwo {
      position: absolute;
      background: #fff;
      width: 100%;
      left: 0;
      border-top: 1px solid #dfdfdf;
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
      .child {
        padding: 0.3rem 0 0.5rem;
        width: 80%;
        margin: auto;
        display: flex;
        justify-content: space-between;
        dd {
          width: 30%;
          background: url("../assets/navTwo-slide-bj.jpg") no-repeat center;
          background-size: cover;
          height: 3rem;
          text-align: center;

          a {
            padding: 0.3rem 0.1rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
            height: 100%;

            /deep/ .el-image {
              height: 70%;
              display: flex;
              align-items: center;
              justify-content: center;

              img {
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
                transition: 0.5s;
              }
            }
            span {
              display: block;
              color: #333;
            }

            &:hover {
              /deep/ .el-image {
                img {
                  transform: scale(1.05);
                }
              }
            }
          }
        }
      }
    }

    /* 产品下拉 */
    .proDown {
      position: absolute;
      width: 100%;
      left: 0;
      background-color: #fff;
      padding: 0.3rem;
      border-top: 1px solid #eee;
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
      .layui-tab {
        display: flex;
        .tabs-header {
          flex: 1;
          max-width: calc(100% - 70%);
          position: relative;
          padding-right: 0.5rem;
          border-right: 1px solid rgba(220, 220, 220, 0.5);
          box-sizing: border-box;
          li {
            margin: 0.2rem 0;
          }
          li a {
            padding: 0.1rem 0.22rem;
            border-radius: 100px;
            font-size: var(--font15);
            position: relative;
            display: inline-block;
            z-index: 1;
          }
          li a::after {
            content: "";
            position: absolute;
            z-index: -1;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(-21deg, #001ff5 0%, #41b9e0 100%);
            border-radius: 100px;
            transition: 0.5s;
            opacity: 0;
          }
          li.layui-this a {
            color: #fff;
          }
          li.layui-this a::after {
            opacity: 1;
            color: #fff;
          }
        }
        .tabs-body {
          width: 70%;
          padding-left: 0.5rem;
          box-sizing: border-box;
          .item {
            display: none;
          }
          .item.layui-show {
            display: block;
          }
          .item ul {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 0.3rem;
          }
          .item li {
            text-align: center;
          }
          .item li .imgBox {
            height: 2.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .item li .imgBox img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            transition: 0.5s;
          }
          .item li span {
            font-size: var(--font15);
            display: block;
            margin-top: 0.1rem;
            color: #333;
          }
          .item li:hover .imgBox img {
            transform: scale(1.025);
          }
        }
      }
    }
  }

  // 右侧
  .header-right {
    .car {
      margin-right: 0.4rem;
      position: relative;

      .mark {
        position: absolute;
        top: -25%;
        left: 50%;

        /deep/ .el-badge__content {
          background: #f10000;
        }
      }
    }
  }
}

/deep/ .el-popover {
  width: max-content !important;
}

.userPopover {
  min-width: 300px;
  .userTop {
    border-bottom: 1px solid #dfdfdf;
    padding: 0.1rem 0;
    .imgBox {
    }
    .info {
      margin-left: 0.2rem;
      .tip {
        margin-top: 0.05rem;
        display: inline-flex;
        align-items: center;
        color: #fff;
        background: linear-gradient(to right, #44d2ff 0%, #001ff5 100%);
        padding: 3px 6px;
        border-radius: 3px;
        align-items: center;
      }
    }
  }

  .userBom {
    padding: 0.1rem 0 0 0;
    justify-content: flex-end;

    .item {
      margin-left: 0.2rem;
      color: #333;
      font-size: var(--font14);

      &:hover {
        color: #4090e5;
      }
    }
  }
}
</style>
